import type { LabelData } from "@roman/shared/hooks/PredictionMarket/usePredictionMarketLabels";

export const DEFAULT_LABELS_PREDICTION_MARKET: LabelData[] = ["人気", "New"];
